import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["MeasurementExport"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postMeasurementExportGetZipped: build.mutation<
        PostMeasurementExportGetZippedApiResponse,
        PostMeasurementExportGetZippedApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasurementExport/GetZipped`,
          method: "POST",
          params: {
            from: queryArg["from"],
            to: queryArg.to,
            measuringPoints: queryArg.measuringPoints,
            oscilloscope: queryArg.oscilloscope,
            rms: queryArg.rms,
          },
        }),
        invalidatesTags: ["MeasurementExport"],
      }),
      postMeasurementExportGetZippedByIds: build.mutation<
        PostMeasurementExportGetZippedByIdsApiResponse,
        PostMeasurementExportGetZippedByIdsApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasurementExport/GetZippedByIds`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["MeasurementExport"],
      }),
      postMeasurementExportExportFaultRecordingstoS3: build.mutation<
        PostMeasurementExportExportFaultRecordingstoS3ApiResponse,
        PostMeasurementExportExportFaultRecordingstoS3ApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasurementExport/ExportFaultRecordingstoS3`,
          method: "POST",
          params: {
            start: queryArg.start,
            end: queryArg.end,
            measuringPoints: queryArg.measuringPoints,
          },
        }),
        invalidatesTags: ["MeasurementExport"],
      }),
      postMeasurementExportGet: build.mutation<
        PostMeasurementExportGetApiResponse,
        PostMeasurementExportGetApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasurementExport/Get`,
          method: "POST",
          body: queryArg.body,
          params: {
            from: queryArg["from"],
            to: queryArg.to,
            measuringPoint: queryArg.measuringPoint,
            manufacturer: queryArg.manufacturer,
            dataClass: queryArg.dataClass,
            mailAddress: queryArg.mailAddress,
          },
        }),
        invalidatesTags: ["MeasurementExport"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as measurementExportApi };
export type PostMeasurementExportGetZippedApiResponse = /** status 200 OK */
  | void
  | /** status 204 No Content */ void
  | /** status 206 Partial Content */ void;
export type PostMeasurementExportGetZippedApiArg = {
  from: string;
  to: string;
  measuringPoints: string;
  oscilloscope: boolean;
  rms: boolean;
};
export type PostMeasurementExportGetZippedByIdsApiResponse =
  /** status 200 OK */
    | void
    | /** status 204 No Content */ void
    | /** status 206 Partial Content */ void;
export type PostMeasurementExportGetZippedByIdsApiArg = number[];
export type PostMeasurementExportExportFaultRecordingstoS3ApiResponse =
  /** status 200 OK */ void;
export type PostMeasurementExportExportFaultRecordingstoS3ApiArg = {
  start: string;
  end: string;
  measuringPoints?: string;
};
export type PostMeasurementExportGetApiResponse = /** status 200 OK */ string;
export type PostMeasurementExportGetApiArg = {
  from: string;
  to: string;
  measuringPoint: string;
  manufacturer: string;
  dataClass: string;
  mailAddress?: string;
  body: string;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  usePostMeasurementExportGetZippedMutation,
  usePostMeasurementExportGetZippedByIdsMutation,
  usePostMeasurementExportExportFaultRecordingstoS3Mutation,
  usePostMeasurementExportGetMutation,
} = injectedRtkApi;
